import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import MobileBottomBar from "@/components/layout/MobileBottomBar";
import ProtectedRoute from "@/components/ProtectedRoute";
import WelcomeModal from "@/components/WelcomeModal";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import IVTherapy from "@/pages/IVTherapy";
import Memberships from "@/pages/Memberships";
import BookConsult from "@/pages/BookConsult";
import Quiz from "@/pages/Quiz";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Guide from "@/pages/Guide";
import GuideArticle from "@/pages/GuideArticle";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import { Login, Register } from "@/pages/Auth";
import MemberPortal from "@/pages/MemberPortal";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/iv-therapy" element={<IVTherapy />} />
            <Route path="/memberships" element={<Memberships />} />
            <Route path="/book/consult" element={<BookConsult />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:id" element={<ProductDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/guide/:slug" element={<GuideArticle />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/portal/*" element={<ProtectedRoute><MemberPortal /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          </Routes>
          <Footer />
          <MobileBottomBar />
          <WelcomeModal />
          <Toaster richColors position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
